<template>
  <div class="popup-container">
    <div class="popup" :class="type">
      <h3 class="title">{{ modele[type].title }}</h3>
      <p class="subtile">{{ modele[type].subtile }}</p>
      <p class="message" v-show="modele[type].message">{{ modele[type].message }}</p>
      <p class="error" v-show="error">{{ error }}</p>
      <div class="field" v-for="field in modele[type].fields">
        <input v-model="field.variable" :type="field.type" :placeholder="field.placeholder">
      </div>
      <div class="actions-container">
        <button class="close" @click="closePopup">Fermer</button>
        <button v-show="modele[type].validateButtons" @click="modele[type].validateButtons.action"
                :class="modele[type].validateButtons.type">
          {{ modele[type].validateButtons.text }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import 'hooper/dist/hooper.css';
import {mapActions} from 'vuex';
import {store} from "../../store/store";

export default {
  name: 'Loader',
  props: {
    type: String,
    body: Object,
    successList: Array,
  },
  data() {
    return {
      responses: null,
      codemask: '',
      error: null,
      modele: {
        addmask: {
          title: 'Ajouter un masque',
          subtile: 'Inscrivez votre numero de masque',
          fields: [
            {
              type: 'text',
              placeholder: 'AH-XXX-XXX',
              variable: ''
            }
          ],
          validateButtons: {
            type: 'validate',
            text: 'Valider',
            action: this.saveMask
          }
        }
      }
    }
  },
  methods: {
    ...mapActions([
      "addMask"
    ]),
    closePopup() {
      this.$emit('close-popup')
    },
    saveMask() {

      if (this.modele.addmask.fields[0].variable !== '') {

        this.addMask(this.modele.addmask.fields[0].variable).then(res => {

          if (res.successList) {
            store.state.successBase = res.successList.filter(function (el) {
              return el.condition === null
            })
            store.state.success = res.successList.filter(function (el) {
              return el.condition != null
            })

          }

          this.$emit('response', res)

        })

        this.error = ''
      } else {
        this.error = 'Espace vide'
      }
    }
  },
  mounted() {
  }
}

</script>

<style scoped>
.popup-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
}

.popup {
  position: relative;
  margin: auto;
  background: #fff;
  border-radius: 10px;
  /*border:2px solid #00d6ff;*/
  min-width: 30%;
  min-height: 10vh;
  padding: 10px 10px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.popup h2 {
  text-align: center;
  color: #00d6ff;
  font-weight: 200;
  margin: 0;
}

.popup p {
  text-align: center;
  font-family: Poppins;
  font-size: 12px;
}

.field {
  display: flex;
}

.field input {
  margin: auto;
  padding: 5px;
  border-radius: 5px;
  border: 1px solid #00d6ff;
  transition: .3S;
}

.actions-container {
  position: absolute;
  bottom: -25px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.actions-container > * {
  width: 40%
}

.popup .title {
  margin: 0;
  color: var(--main-color);
  text-transform: uppercase;
  font-family: var(--main-title-font);
}

.validate {
  text-transform: uppercase;
  font-family: var(--main-title-font);
  font-weight: 600;
  background: #00d6ff;
  color: white;
  border: 1px solid #00d6ff;
  border-radius: 5px;
  padding: 5px 20px;
  margin: 10px;
}

.error {
  margin: 0;
  padding: 0;
  color: #ff5047;
}

.close {
  color: #fff;
  background: var(--main-red-color);
  transition: .3s;
  padding: 5px 20px;
  border: 1px solid var(--main-red-color);
  text-transform: uppercase;
  font-family: var(--main-title-font);
  font-weight: bold;
  border-radius: 5px;
  margin: 10px;
}

.close:hover, .validate:hover {
  cursor: pointer;

}

.form_response.error {
  width: 75%;
  margin: 15px auto auto auto;
  background-color: #ff3333;
  color: #fff;
  border-radius: 10px;
  /*position: absolute;*/
  /*font-family: "Bebas Neue";*/
}

.form_response.succeed {
  width: 75%;
  margin: 15px auto auto auto;
  background-color: #65c249;
  color: #fff;
  border-radius: 10px;
  /*position: absolute;*/
  /*font-family: "Bebas Neue";*/
}

.form_response.warning {
  width: 75%;
  margin: 15px auto auto auto;
  background-color: #ff8334;
  color: #fff;
  border-radius: 10px;
  /*position: absolute;*/
  /*font-family: "Bebas Neue";*/
}

.content_response {
  position: absolute;
  top: 0;
  width: 100%;
}

.form_response p {
  /*font-family: Calibri;*/
  text-align: center;
  padding: 10px 10px;
  white-space: pre-line;
  font-weight: bold;
}


/*    EXCEPTION DESKTOP  */
@media screen and (min-width: 750px) {
  .popup {
    margin-top: calc(50% - 30%);

  }
}


/*    EXCEPTION MOBILE*/
@media screen and (max-width: 750px) {

  .popup {
    min-width: 80%;
  }
}

</style>
